<ng-container *ngFor="let polygonOptions of polygonOptions;">
    <map-polygon [options]="polygonOptions" (polygonClick)="handlePolygonClick($event, polygonOptions)"></map-polygon>
</ng-container>

<ng-container *ngFor="let circleOptions of circleOptions;">
    <map-circle [options]="circleOptions" (circleClick)="handleCircleClick($event, circleOptions)"></map-circle>
</ng-container>